module.exports = __webpack_public_path__ + "static/media/018.4c875541.jpg";